import { hotkeyPrefix } from '@shared/constants/CommandValues';
import { useEditProfileStore } from '@shared/hooks/state/EditProfileContainer';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import ContentDialog from '../core/dialog/ContentDialog';
import { BodyMedium } from '../core/text/Typography';

const DeprecatedHotkeyDialog: React.FC = () => {
    const { t } = useTranslation();
    const hotkeys = useEditProfileStore((state) => state.hotkeys);
    const macros = useEditProfileStore((state) => state.macros);
    const isDeprecatedHotkey = useEditProfileStore((state) => state.isDeprecatedHotkey);
    const navigate = useNavigate();
    const onConfirm = async () => {
        hotkeys.forEach((hotkey) => {
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            hotkey.command.startsWith(hotkeyPrefix)
                ? null
                : useEditProfileStore.getState().updateDeprecatedHotkey(hotkey, macros);
        });
        const result = await useEditProfileStore.getState().saveChanges();
        if (result?.resultType == 'Ok') {
            useEditProfileStore.getState().setIsDeprecatedHotkey(false);
            navigate(`/profiles/edit/${result?.data?.id}`, { replace: true });
        }
        useEditProfileStore.getState().setIsDeprecatedHotkey(false);
    };
    return (
        <ContentDialog
            open={isDeprecatedHotkey}
            onClose={onConfirm}
            description={t('common:hotkey.deprecatedDialog.description1')}
            title={t('common:hotkey.deprecatedDialog.title')}
            onConfirm={onConfirm}
            confirmButtonText={t('common:hotkey.deprecatedDialog.confirm')}>
            <BodyMedium>{t('common:hotkey.deprecatedDialog.description2')}</BodyMedium>
        </ContentDialog>
    );
};

export default DeprecatedHotkeyDialog;
